import React, { memo } from "react";
import Icon from "../../../../core/components/Icon.tsx";
import { DropdownSectionProps } from "../interfaces/Dropdown.interfaces.tsx";

const DropdownSection = ({
	titleSection,
	children,
	icon,
}: DropdownSectionProps) => {
	return (
		<div className="dropdown-content-2">
			<div className="titulo-navbar-icone">
				<Icon name={icon} size="xl" theme="dark" />
				<span className="titulo-navbar-texto">{titleSection}</span>
			</div>
			{children}
		</div>
	);
};

export default memo(DropdownSection);
